import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import TrashSvg from '../../../assets/icons/app/trash.svg?raw';

export const TrashIcon = (props) => <CustomSVG svg={TrashSvg} preserveColors appIconSmall {...props} />;
